export function isClassDecoratorArgs(Target) {
  return arguments.length === 1 && arguments[0] instanceof Function;
}

export function decorateClass(Decorated) {
  const Target = Object.getPrototypeOf(Decorated);
  const Base = Object.getPrototypeOf(Target);
  Object.setPrototypeOf(Decorated.prototype, Base.prototype);
  Object.setPrototypeOf(Decorated, Base);
  Object.setPrototypeOf(Target.prototype, Decorated.prototype);
  Object.setPrototypeOf(Target, Decorated);
  return Target;
}

export function isMemberDecoratorArgs(target, propertyKey, descriptor) {
  return arguments.length === 3 && target instanceof Object
    && typeof propertyKey === 'string' && descriptor instanceof Object;
}

export function isDecoratorArgs() {
  return isClassDecoratorArgs(...arguments) || isMemberDecoratorArgs(...arguments);
}

export function isMethodDecoratorArgs(target, propertyKey, descriptor) {
  return isMemberDecoratorArgs(...arguments)
    && descriptor.value instanceof Function;
}

export function isAccessorDecoratorArgs(target, propertyKey, descriptor) {
  return isMemberDecoratorArgs(...arguments)
    && (descriptor.get instanceof Function || descriptor.set instanceof Function);
}

export function isGetAccessorDecoratorArgs(target, propertyKey, descriptor) {
  return isMemberDecoratorArgs(...arguments)
    && descriptor.get instanceof Function;
}

export function isSetAccessorDecoratorArgs(target, propertyKey, descriptor) {
  return isMemberDecoratorArgs(...arguments)
    && descriptor.set instanceof Function;
}

export function isPropertyDecoratorArgs(target, propertyKey, descriptor) {
  return isMemberDecoratorArgs(...arguments) && !isMethodDecoratorArgs(...arguments)
    && !isGetAccessorDecoratorArgs(...arguments);
}

export function isPropertyOrGetAccessorDecoratorArgs(target, propertyKey, descriptor) {
  return isMemberDecoratorArgs(...arguments) && !isMethodDecoratorArgs(...arguments);
}

export function getDescriptorValue(target, propertyKey, descriptor) {
  return descriptor ? (
    descriptor.get ? descriptor.get()
      : descriptor.initializer ? descriptor.initializer()
      : undefined
  ) : undefined;
}

export function getDecoratorDescriptorValue(target, propertyKey, descriptor) {
  return getDescriptorValue(descriptor);
}
